import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import containImg from '@blade-sxp/monitor-center/pages/components/big-data-detail/contain-img.vue';
import Details from '@blade-sxp/monitor-center/pages/components/big-data-detail/details.vue';
import moment from 'moment';
//  clusterResultDetail
import { getRuleData, clusterResultDetail } from '@blade-sxp/monitor-center/api/index';
// interface Rule {
//   days: number;
//   effectiveTime: number;
//   portraitLibrary: string;
//   times: number;
//   fail: boolean;
// }
let default_1 = class default_1 extends Vue {
    data;
    dialogVisible = false;
    routeQuery = this.$route.query;
    moment = moment;
    pageSize = 1000;
    viewPageNum = 1;
    totalPage = 1;
    pageNum = 1;
    loading = false;
    rule = {
        // days: 1,
        // effectiveTime: 10,
        // portraitLibrary: '',
        // times: 1,
        // fail: true,
        count: 0,
        days: 0,
        docId: 0,
        libName: '',
        repeatTime: 0,
        fail: true,
    };
    timer = null;
    showSize = 3;
    viewData = null;
    indexInfo = [];
    imageList = [];
    get showList() {
        if (!this.imageList.length)
            return [];
        const arr = [[]];
        let time = new Date(this.imageList[this.imageList.length - 1].captureTime).getTime();
        // this.imageList.forEach(e => {
        //   e.onShow = false;
        //   // 返回的是秒数
        //   if (+time - +e.captureTime <= 60 * this.rule.effectiveTime) {
        //     arr[arr.length - 1].push(e);
        //   } else {
        //     arr[arr.length] = [e];
        //     time = e.captureTime;
        //   }
        // });
        for (let i = this.imageList.length - 1; i >= 0; i--) {
            const e = this.imageList[i];
            e.onShow = false;
            // 返回的是秒数
            if (new Date(e.captureTime).getTime() - time <= this.rule.repeatTime * 1000) {
                arr[0].unshift(e);
            }
            else {
                arr.unshift([e]);
                time = new Date(e.captureTime).getTime();
            }
        }
        return arr;
    }
    get repeatTime() {
        const time = (this.rule.repeatTime / 60).toFixed();
        return time;
    }
    // imgs[imgs.length - 1].portraitImage
    returnImgUrl(item) {
        let imgObj = {
            imgUrl: '',
            showImg: false,
        };
        if (item?.portraitImage) {
            imgObj.imgUrl = item.portraitImage;
            imgObj.showImg = true;
        }
        return imgObj;
    }
    returnDeviceName(item) {
        let deviceName = '';
        if (item?.deviceName) {
            deviceName = item.deviceName;
        }
        return deviceName;
    }
    returnCaptureTime(item) {
        let captureTime = '';
        if (item?.captureTime) {
            captureTime = item.captureTime;
        }
        return captureTime;
    }
    addPage(imgs, index) {
        this.indexInfo[index].pageNum = Math.min(this.indexInfo[index].pageNum + 1, 10);
    }
    redPage(imgs, index) {
        this.indexInfo[index].pageNum = Math.min(this.indexInfo[index].pageNum - 1, 10);
    }
    clusterResultDetail() {
        this.loading = true;
        if (!this.rule.docId) {
            this.loading = false;
            return;
        }
        const params = {
            page: this.pageNum,
            size: this.pageSize,
            pageOrderList: [{ orderField: 'create_time', orderType: 'DESC' }],
            docId: this.rule.docId,
        };
        if (this.pageNum > this.totalPage)
            return;
        clusterResultDetail(params)
            .then((res) => {
            this.pageNum++;
            this.imageList = this.imageList.concat(res.list);
            this.totalPage = res.totalPage;
            this.indexInfo = this.isGold();
        })
            .finally(() => {
            this.loading = false;
        });
    }
    isGold() {
        const arr = this.showList.map((e, i) => {
            // if (e.length - 1 === 0) {
            return {
                pageNum: 1,
                time: e[e.length - 1]?.captureTime,
                isGold: false,
            };
            // }
        });
        const days = this.rule.days;
        const times = this.rule.count;
        // window.moment = moment;
        // console.log('打印', times, arr);
        if (this.rule.fail || arr.length < times)
            return arr;
        // 需要满足规则days自然日出现times次的高亮
        arr.some((e, i) => {
            // console.log('打印', i, times, arr);
            if (i + times > arr.length)
                return true;
            const timesArr = new Array(days).fill(0).map((emp, index) => {
                return moment(e.time).subtract(index, 'days').format('YYYY-MM-DD');
            });
            const restArr = arr.slice(i + 1, i + times); // 从时间挨着的接下来的times-1个数组中匹配满足条件的
            if (restArr.every((rest) => timesArr.includes(moment(rest.time).format('YYYY-MM-DD')))) {
                e.isGold = true;
                restArr.forEach((rest) => {
                    rest.isGold = true;
                });
                return true;
            }
            else {
                return false;
            }
        });
        return arr;
    }
    async getRuleData() {
        if (!this.data?.faceAnnotation?.portraitId) {
            return;
        }
        try {
            await getRuleData({ id: this.data.faceAnnotation.portraitId }).then((res) => {
                if (!res)
                    return (this.rule.fail = true);
                // console.log('getRuleData', res);
                this.rule = res;
                this.rule.fail = false;
                if (this.rule.count === null &&
                    this.rule.days === null &&
                    this.rule.docId === null &&
                    this.rule.libName === null &&
                    this.rule.repeatTime === null) {
                    this.rule.fail = true;
                }
            });
        }
        catch (err) {
            this.rule.fail = true;
        }
    }
    showDetail(e, imgs) {
        this.viewData = e;
        this.dialogVisible = true;
    }
    async mounted() {
        // const dom = document.querySelector('.container .right') as HTMLElement;
        // const width = dom.offsetWidth - 260;
        // let n = Math.floor((width + 5) / 123);
        // this.showSize = Math.min(n, 9);
        await this.getRuleData();
        this.clusterResultDetail();
    }
    onScroll(e) {
        if (this.timer)
            clearTimeout(this.timer);
        const target = e.target;
        const scrollHeight = target.scrollHeight;
        const scrollTop = target.scrollTop;
        const height = target.clientHeight;
        if (scrollTop > scrollHeight - height - 100) {
            // 当滚动条滑动到离底部距离100px的位置的时候开始调用接口
            if (this.pageNum <= this.totalPage) {
                this.timer = setTimeout(() => {
                    this.clusterResultDetail();
                }, 200);
            }
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
default_1 = __decorate([
    Component({
        name: 'big-data-result',
        components: { containImg, Details },
        i18n: {
            messages: {
                zh: {
                    alertResult: '告警结果',
                    clusterResult: '聚档结果',
                    filterTime: '人像重复过滤时间：',
                    min: '分钟',
                    logic: '大数据挖掘逻辑：',
                    rule: '该人员在{days}天内出现{times}次，并被推到{portraitLibrary}',
                    unknown: '未知身份',
                    none: '无',
                },
                en: {
                    alertResult: 'Alert Result',
                    clusterResult: 'Clustering File Result',
                    filterTime: 'Portrait Repeat Filter Time: ',
                    min: 'Min',
                    logic: 'Big Data Mining Logic: ',
                    rule: 'It appears {times} times in {days} days and it is pushed to {portraitLibrary}',
                    unknown: 'Anonymous',
                    none: 'No Rule',
                },
            },
        },
    })
], default_1);
export default default_1;
